<template>
  <div>
    <sidebar-menu
      class="sidebar-style overflow-y-auto"
      :menu="menu"
      :relative="true"
      :hideToggle="true"
      :collapsed="$store.state.sidebarv2Collapse"
      @toggle-collapse="onToggleCollapse"
      :showOneChild="true"
      :showChild="$store.state.showChildRsSidebar"
      @item-click="onItemClick"
    >
      <span
        class="text-center"
        style="color:white; margin-top:15px"
        slot="header"
      >
        <!-- <font-awesome-icon class="fa-2x" icon="home" /> -->
        <logoSheild
          v-if="$store.state.sidebarv2Collapse"
          :logoProps="logo"
        />
        <Logo
          v-else
          :logoProps="logo"
        />
        <hr style="background-color:#adadad" />
      </span>

      <!-- :showOneChild="showOneChild" -->
      <span slot="dropdown-icon">
        <font-awesome-icon icon="caret-down" />
      </span>
      <span slot="toggle-icon">
        <font-awesome-icon icon="caret-up" />
      </span>
    </sidebar-menu>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import logoSheild from "../logo/logoSheild.vue";
import Logo from "../logo/logo.vue";

export default {
  name: "SidebarV2",
  components: {
    logoSheild,
    Logo,
  },
  props: {},
  created () {
    EventBus.$on( "ToggleCollapse", ( data ) => {
      this.onToggleCollapse();
    } );
  },
  data () {
    return {
      userType: null,

      logo: {
        width: "auto",
        height: "35px",
      },
      menu: [
        {
          title: "Dashboard",
          href: "/dashboard",
          icon: "fa fa-home",
          hidden: false,
        },
        {
          title: "Manage Employee",
          href: "/manage-employee",
          hidden: false,
          icon: "fa fa-users",
        },
        {
          title: "Tasks",
          icon: "fa fa-thumbtack",
          href: "/tasks",
          hidden: false,
        },
        // {
        //   title: "Training & Exams",
        //   icon: "fa fa-clipboard",

        //   child: [
        //      {
        //       title: "All",
        //       href: "/training-exams",
        //     },
        //     {
        //       title: "In Progress",
        //       href: "/training-exams",
        //     },
        //     {
        //       title: "Overdue",
        //       href: "/training-exams",
        //     },
        //     {
        //       title: "Not Sent",
        //       href: "/training-exams",
        //     },
        //   ]

        // },
        // {
        //   title: "Governance",
        //   icon: "fa fa-balance-scale",
        //   href: "/goverance/one",
        //   hidden: false,
        // },
        {
          title: "Gifts & Hospitality",
          icon: "fa fa-gift",
          href: "/employee-approval-list",
          hidden: false,
        },
        {
          title: "Complaints",
          icon: "fa fa-balance-scale",
          href: "/complaints-dashboard",
          hidden: false,
        },
        // {
        //   title: "Reports",
        //   icon: "fa fa-chart-bar",
        //   href: "/mis-graph",
        //   hidden: false,
        // },
        {
          title: "Settings",
          icon: "fa fa-cog",
          hidden: false,
          child: [
            {
              title: "General Settings",
              hidden: false,
              child: [
                {
                  href: "/approval-type",
                  title: "Approval Type",
                  hidden: false,
                },
                {
                  href: "/departments",
                  title: "Division/Business Unit",
                  hidden: false,
                },
                {
                  href: "/email-tags",
                  title: "Email Tags",
                  hidden: false,
                },
              ],
            },
            {
              title: "Platform",
              href: "/platform-settings",
              hidden: false,
            },
            {
              title: "Workflows",
              hidden: false,
              child: [
                {
                  href: "/workflows-hr",
                  title: "Human Resources",
                },
                // {
                //   href: "/workflows-it",
                //   title: "IT",
                // },
              ],
            },
            {
              title: "Forms",
              hidden: false,
              child: [
                {
                  href: "/employee-onboarding",
                  title: "All Forms",
                },
              ],
            },
            // {
            //   href: "/custom-fields",
            //   title: "Custom Fields",
            // },
            // {
            //   href: "/styling",
            //   title: "Styling",
            // },
            // {
            //   href: "/access-control",
            //   title: "Access Control",
            // },
          ],
        },
      ],
    };
  },
  mounted () {
    this.userType = localStorage.getItem( "userType" );
    this.hideShowSideBarMenu();
  },
  methods: {
      onItemClick(event,item){
      if(item.title != 'Forms'){
        this.$store.state.showChildRsSidebar = false
      }
    },
    onToggleCollapse () {
      this.$store.state.sidebarv2Collapse = !this.$store.state
        .sidebarv2Collapse;
    },
    hideShowSideBarMenu () {
      this.menu.map( ( fields ) => {
        if ( fields.title == "Dashboard" ) {
          fields.hidden = this.userType == 1 ? true : false;
        } else {
          fields.hidden = this.userType == 3 ? true : false;
        }
        if ( fields.child ) {
          fields.child.map( ( childFields ) => {
            if ( childFields.title == "Platform" ) {
              childFields.hidden = this.userType == 1 ? false : true;
            }
            if ( childFields.title == "Forms" ) {
              childFields.hidden = (this.userType == 1) ? false : true;
            }
            if ( childFields.title == "General Settings" ) {
              childFields.child.map( ( secondChild ) => {
                if ( secondChild.title == "Email Tags" ) {
                  secondChild.hidden =
                    process.env.VUE_APP_DEVEVLOPER_ONLY == 1 ? false : true;
                }
              } );
            }
          } );
        }
      } );
    },
  },
};
</script>

<style>
@import "../../assets/styles/theme1/sidebar.css";
</style>
